import axios from "~/plugins/axios";

const baseUrl = "/web_api/v1/note";

export default {
  find(id, includes = []) {
    return axios.get(`${baseUrl}/${id}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  update(note) {
    const url = `${baseUrl}/${note.id}`;
    return axios.put(url, note)
      .then((response) => response.data);
  },
  create(note) {
    return axios.post(`${baseUrl}`, note).then((response) => response.data);
  },
  delete(note) {
    return axios.delete(`${baseUrl}/${note.id}`, note)
      .then((response) => response.data);
  },
  createByInstance(note) {
    return axios.post(`${baseUrl}/storeByInstance`, note).then((response) => response.data);
  },
  paginateByInstance(
    instance,
    page = 1,
    perPage = 15,
    orderBy = "created_at",
    order = "desc",
    includes = [],
    filter = {},
  ) {
    return axios.post(`${baseUrl}/paginate_by_instance`, {
      instance,
      page,
      perPage,
      orderBy,
      order,
      includes,
      filter,
    }).then((response) => response.data);
  },
  paginateByFamilyCategory(
    customerId,
    category,
    page = 1,
    perPage = 15,
    orderBy = "created_at",
    order = "desc",
    includes = [],
    filter = {},
  ) {
    return axios.post(`${baseUrl}/paginate_by_family_category`, {
      customerId,
      category,
      page,
      perPage,
      orderBy,
      order,
      includes,
      filter,
    }).then((response) => response.data);
  },
  countByInstance(instanceId, instanceClass) {
    return axios.post(`${baseUrl}/count_by_instance`, {
      instance: {
        id: instanceId,
        class: instanceClass,
      },
    }).then((response) => response.data);
  },
  countByFamilyAndCategory(customerId, categoryId) {
    return axios.post(`${baseUrl}/count_by_family_and_category`, {
      customer_id: customerId,
      category: categoryId,
    }).then((response) => response.data);
  },
};
